import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AuthProvider } from "app/contexts/JWTAuthContext";
import { SettingsProvider } from "app/contexts/SettingsContext";
import { Provider } from "react-redux";
import Maintenance from "./views/sessions/Maintenance"
import { maintenance } from "config.js";
import { useRoutes } from "react-router-dom";
import { AppTheme } from "./components";
import store from "./redux/Store";
import routes from "./routes";
import "../fake-db";

const App = () => {
  const content = useRoutes(routes);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Provider store={store}>
        <SettingsProvider>
          <AppTheme>
            <AuthProvider>{content}</AuthProvider>
          </AppTheme>
        </SettingsProvider>
      </Provider>
    </LocalizationProvider>
  );
};

export default App;
